import { render } from "./cardReturnRecordModel.vue?vue&type=template&id=c6eb24ac"
import script from "./cardReturnRecordModel.vue?vue&type=script&lang=js"
export * from "./cardReturnRecordModel.vue?vue&type=script&lang=js"

import "./cardReturnRecordModel.vue?vue&type=style&index=0&id=c6eb24ac&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__